import React from "react";
import Wave from "react-wavify";

const AnimatedWaves = () => {
  return (
    <div className="relative w-full h-32 overflow-hidden">
      {/* Wave 1 */}
      <Wave
        className="absolute inset-0"
        fill="url(#gradient1)"
        options={{ height: 30, amplitude: 60, speed: 0.1, points: 4 }}
        style={{ opacity: 0.8, zIndex: 4, marginTop: "-3%" }}
      >
        <defs>
          <linearGradient id="gradient1" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#9AE5CA" />
            <stop offset="100%" stopColor="#00AA6B" />
          </linearGradient>
        </defs>
      </Wave>

      {/* Wave 2 */}
      {/* <Wave
        className="absolute inset-0"
        fill="url(#gradient2)"
        options={{ height: 30, amplitude: 40, speed: 0.1, points: 4 }}
        style={{ opacity: 0.7, zIndex: 3 }}
      >
        <defs>
          <linearGradient id="gradient2" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#172B4D" />
            <stop offset="100%" stopColor="#FF4BC5" />
          </linearGradient>
        </defs>
      </Wave> */}

      {/* Wave 3 */}
      {/* <Wave
        className="absolute inset-0"
        fill="url(#gradient3)"
        options={{ height: 30, amplitude: 40, speed: 0.1, points: 4 }}
        style={{ opacity: 0.6, zIndex: 2 }}
      >
        <defs>
          <linearGradient id="gradient3" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#FF4BC5" />
            <stop offset="100%" stopColor="#1A43AB" />
          </linearGradient>
        </defs>
      </Wave> */}

      {/* Wave 4 */}
      {/* <Wave
        className="absolute inset-0"
        fill="url(#gradient4)"
        options={{ height: 30, amplitude: 40, speed: 0.1, points: 4 }}
        style={{ opacity: 0.5, zIndex: 1 }}
      >
        <defs>
          <linearGradient id="gradient4" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#FA9E9E" />
            <stop offset="100%" stopColor="#FFBAB1" />
          </linearGradient>
        </defs>
      </Wave> */}
    </div>
  );
};

export default AnimatedWaves;
